import { GlobalSearchListParams } from '../../services/global-search.service';

export type SearchSort = 'name' | 'updated' | 'created';

export const DEFAULT_SEARCH_SORT: SearchSort = 'name';

export const SEARCH_SORT_OPTIONS: readonly { value: SearchSort; label: string }[] = [
  { value: 'name', label: 'Alphabetical (A-Z)' },
  { value: 'updated', label: 'Last Updated' },
  { value: 'created', label: 'Date Created' },
];

export const SORT_TO_ORDERING: Record<SearchSort, NonNullable<GlobalSearchListParams['ordering']>> = {
  name: 'name',
  updated: '-updated_at',
  created: '-created_at',
};

export interface StatusOption {
  /** Sent as `status=`; the backend matches it case-insensitively across projects. */
  value: string;
  label: string;
}

/**
 * The statuses every project is seeded with. Statuses are free text per project and the same for
 * every role, so a project that renamed or added one can't be filtered by it here.
 */
export const REQUEST_STATUS_OPTIONS: readonly StatusOption[] = [
  { value: 'to do', label: 'To Do' },
  { value: 'in progress', label: 'In Progress' },
  { value: 'sent for approval', label: 'Sent for Approval' },
  { value: 'completed', label: 'Completed' },
  { value: 'on hold', label: 'On Hold' },
];

/** The Figma filter's defaults for Requests Assigned. */
export const DEFAULT_ASSIGNED_STATUSES: readonly string[] = ['to do', 'in progress'];
